// Reminder delays on Settings > Notifications: each reminder can only be later than the one before it,
// and a later reminder can't be set while an earlier one is "Don't send".
export default class extends HTMLElement {
  connectedCallback () {
    this.selects = [...this.querySelectorAll('select[data-reminder-step]')]
    this.selects.forEach((select) => select.addEventListener('change', this.update))
    this.update()
  }

  disconnectedCallback () {
    this.selects.forEach((select) => select.removeEventListener('change', this.update))
  }

  // Options are listed shortest first, so "later" means a higher option index.
  update = () => {
    let previousIndex = null

    this.selects.forEach((select) => {
      const options = [...select.options]
      const durationIndex = (option) => options.filter((o) => o.value).indexOf(option)
      select.disabled = previousIndex === false

      options.forEach((option) => {
        option.disabled = Boolean(option.value) && typeof previousIndex === 'number' &&
          durationIndex(option) <= previousIndex
      })

      if (select.disabled) {
        select.value = ''
      } else if (select.selectedOptions[0]?.disabled) {
        select.value = options.find((option) => option.value && !option.disabled)?.value || ''
      }

      const selected = select.selectedOptions[0]
      previousIndex = selected?.value ? durationIndex(selected) : false
    })
  }
}
